import { gql } from '@apollo/client';

const GET_CONTRACTOR_LIST = gql`
  query contractors($clientId: ID!) {
    contractors(clientId: $clientId) {
      id
      name
    }
  }
`;

export { GET_CONTRACTOR_LIST };
